import React, { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../component/table/Table";
import { orderTableColumnsConfig } from "./orderTableColumnsConfig";
import { useSelector } from "react-redux";
import {
  selectOrders,
  selectOrdersQueryArg,
  useGetOrdersListQuery,
} from "../../../services/order/orderApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const OrderTablePage = ({ data }) => {
  const navigate = useNavigate();

  const queryArg = useSelector(selectOrdersQueryArg);

  const { isSuccess, isLoading, isFetching } = useGetOrdersListQuery(queryArg);

  const orders = useSelector(selectOrders);

  // Navigate to order detail page
  const handleNavigateToDetail = useCallback(
    (orderId) => {
      navigate(`/orders/${orderId}`);
    },
    [navigate],
  );

  // Column definitions for table
  const columnDefs = useMemo(
    () => orderTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail],
  );

  return isSuccess ? (
    <Table
      data={orders}
      columns={columnDefs}
      loading={isLoading || isFetching}
    />
  ) : (
    <CategoryPageSkeleton />
  );
};
